module.exports = __webpack_public_path__ + "static/media/Dropdown.513c66cb.svg";